import { render } from "./InventoryManagementPage.vue?vue&type=template&id=498c097c"
import script from "./InventoryManagementPage.vue?vue&type=script&lang=js"
export * from "./InventoryManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__